import React from "react";
import ReactDOM from "react-dom";
import { loadCss } from "../../wea-tools/loadCss";

export default class ExtendsContainer extends React.Component {
  append() {
    const { children } = this.props;
    ReactDOM.unstable_renderSubtreeIntoContainer(
      this,
      children,
      this.container
    );
  }
  componentDidMount() {
    const {
      container,
      style,
      className,
      position = "last",
      insertChildNode,
      onClick,
      title
    } = this.props;
    if (!insertChildNode) {
      // 插入图标到最前或者最后
      this.container = document.createElement("div");
      this.container.className =
        className === void 0 ? "wea-rich-text-extents" : className;
      for (const key in style) {
        if (style.hasOwnProperty(key)) {
          this.container.style[key] = style[key];
        }
      }
      position === "first"
        ? container.insertBefore(this.container, container.firstChild)
        : container.appendChild(this.container);
    } else {
      // 插入图标到指定的位置
      this.container = document.createElement("a");
      this.container.className = className;
      this.container.title = title;
      this.container.onclick = onClick;
      container.insertBefore(this.container, insertChildNode);
    }
    this.append();
    loadCss();
  }
  componentWillReceiveProps(nextProps) {
    const { className, insertChildNode } = nextProps;
    // 插入到指定位置模式: 切换源码模式的时候,className要同步更新
    if (insertChildNode && className !== this.props.className) {
      this.container.className = className;
    }
  }
  componentDidUpdate() {
    this.append();
  }
  componentWillUnmount() {
    const { container } = this.props;
    container && container.removeChild(this.container);
  }
  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-rich-text/components/ExtendsContainer.js